import * as types from "./mutation_types";
const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const send = ({ commit }, values) => {
  commit(types.RELANCE_SEND_TOGGLE_LOADING);
  axios
    .post(URL_BACKEND + "api-relance/send/", values)
    .then(() => {
      commit(types.RELANCE_SEND_TOGGLE_LOADING);
    })
    .catch((e) => {
      commit(types.RELANCE_SEND_TOGGLE_LOADING);
      commit(types.RELANCE_SEND_SET_ERROR, e.message);
    });
};
